// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe6c09af","337":"347d0e45","453":"5861f0a7","667":"ac5414c6"}[chunkId] + ".chunk.js";
};